import Vue from 'vue';

export const prepareData = (data) =>
  data.reduce((acc, { id, productId }) => {
    acc[productId] = { id, productId };

    return acc;
  }, {});

export default {
  namespaced: true,

  state: () => ({
    favorites: [],
    favoritesMeta: {
      offset: 0,
      productsMap: {},
      isEnd: false,
      isLoading: false,
      isPrefetched: false,
    },
    favoritesShort: {},
  }),

  getters: {
    isInShortFavorite: state => productId => productId in state.favoritesShort,
    hasFavorites: state => state.favorites.length > 0,
    short: state => state.favoritesShort || {},
    favoritesShortCount: state => Object.keys(state.favoritesShort).length,
  },

  mutations: {
    setShort(state, products) {
      state.favoritesShort = prepareData(products);
    },
    addShort(state, product) {
      Vue.set(state.favoritesShort, product.productId, product);
    },
    removeShort(state, productId) {
      const toRemove = state.favoritesShort[productId];

      if (toRemove) {
        Vue.delete(state.favoritesShort, productId);
      }
    },
    set(state, products) {
      state.favorites = products;
    },
    setMeta(state, meta) {
      state.favoritesMeta = {
        ...state.favoritesMeta,
        ...meta,
      };
    }
  },

  actions: {
    async loadFavoritesShort({ commit }) {
      try {
        const result = await this.$api.loadFavoritesShort();
        commit('setShort', result);
      } catch (e) {
        console.error(e);
      }
    },

    async addToShortFavorites({ commit }, { productId, skuId } = {}) {
      try {
        commit('addShort', {
          productId
        });

        const result = await this.$api.addToFavorites({ productId, skuId });
        commit('setShort', result)
      } catch (e) {
        commit('removeShort', productId);
        console.error(e);
      }
    },

    async removeFromShortFavorites({ commit, state }, productId) {
      const favoriteProduct = state.favoritesShort[productId];

      if (!favoriteProduct) {
        return;
      }

      try {
        commit('removeShort', favoriteProduct.productId);
        await this.$api.removeFromFavorites(favoriteProduct.id);
      } catch (e) {
        commit('addShort', {
          productId
        });

        console.error(e);
      }
    },

    async loadFavorites({ commit, state, dispatch }, { offset = 0, isServer = false } = {}) {
      if (state.favoritesMeta.isEnd || state.favoritesMeta.isLoading) return;
      try {
        commit('setMeta', {
          isLoading: true,
          isPrefetched: isServer || state.favoritesMeta.isPrefetched,
        });

        const productsIds = await dispatch('getFavoritesProductsIds');

        const productsIdsSliced = productsIds.slice(state.favoritesMeta.offset, offset);
        if (!productsIdsSliced.length) {
          commit('setMeta', {
            isLoading: false,
            isEnd: true,
          });
          return;
        }

        const products = await this.$api.loadProducts(productsIdsSliced);

        products.forEach(product => {
          // заносим skuId, чтобы был выбран размер на странице избранное
          product.skuId = state.favoritesMeta.productsMap[product.id];
        });

        commit('set', state.favorites.concat(products));
        commit('setMeta', {
          offset,
          isEnd: offset >= productsIds.length,
        });
      } catch (e) {
        console.error(e);
      } finally {
        commit('setMeta', { isLoading: false });
      }
    },

    async getFavoritesProductsIds({ state, commit }) {
      if (!Object.keys(state.favoritesMeta.productsMap).length) {
        const favorites = await this.$api.loadFavoritesShort();
        const productsMap = favorites.reduce((res, { productId, skuId }) => {
          res[productId] = skuId || null;
          return res;
        }, {});
        commit('setMeta', { productsMap });
      }

      return Object.keys(state.favoritesMeta.productsMap);
    },

    toggle({ dispatch, getters }, { productId, skuId } = {}) {
      if (getters.isInShortFavorite(productId)) {
        dispatch('removeFromShortFavorites', productId);
      } else {
        dispatch('addToShortFavorites', { productId, skuId });
      }
    }
  }
}
